export default __webpack_public_path__ + "static/media/through-user-insights.14513cde.svg";